import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { TColorRole, colorMap } from '../../../types/types';
import { TextCustom } from '../../ui/TextCustom';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';

interface ILoaderProps {
    height?: number;
    width?: number;
    color?: TColorRole;
    radius?: number;
    label?: string;
    gap?: number;
    textColor?: TColorRole;
    hasText?: boolean;
}

export const LoaderThreeDots: React.FC<ILoaderProps> = ({ height = 15, width = 15, color = 'grey-normal', label = '', gap = 0.5, textColor = 'grey-dark', hasText = true, radius = 9 }) => {
    const hexColor = colorMap[color] || colorMap['white'];

    const ovalAndText = (
        <>
            <ThreeDots visible={true} height={height} width={width} radius={radius} color={hexColor} />{' '}
            {hasText && (
                <TextCustom size={1.2} color={textColor}>
                    {label}
                </TextCustom>
            )}
        </>
    );

    return <FlexCenter gap={gap}>{ovalAndText}</FlexCenter>;
};
